import React from 'react'
import { Chart } from 'primereact/chart';
import { fill } from 'lodash';

const Datewise = (props) => {

    const datewiseData = props?.datewiseData || [];

    const groupedData = datewiseData.reduce((acc, item) => {
        const { createDate, status, totalCount } = item;
        if (!acc[createDate]) {
            acc[createDate] = { "Successful": 0, "Checker Approved": 0, "Checker Rejected": 0, "Validation Successful": 0 };
        }
        acc[createDate][status] += totalCount;
        return acc;
    }, {});

    const uniqueDates = Object.keys(groupedData);

    const successfulData = uniqueDates.map(date => groupedData[date]["Successful"]);
    const validationSuccessfulData = uniqueDates.map(date => groupedData[date]["Validation Successful"]);
    const checkerApprovedData = uniqueDates.map(date => groupedData[date]["Checker Approved"]);
    const checkerRejectedData = uniqueDates.map(date => groupedData[date]["Checker Rejected"]);

    const dateWiseData = {
        labels: uniqueDates || [],
        datasets: [
            {
                label: 'Validation Successful',
                backgroundColor: 'rgba(244, 208, 63, 0.2)',
                borderColor: '#f4d03f',
                borderWidth: 1,
                fill: false,
                data: validationSuccessfulData
            },
            {
                label: 'Approved',
                backgroundColor: 'rgba(214, 137, 16, 0.2)',
                borderColor: '#d68910',
                borderWidth: 1,
                fill: false,
                data: checkerApprovedData,
                // hoverBackgroundColor: '#f5b041'
            },
            {
                label: 'Rejected',
                backgroundColor: 'rgba(169, 50, 38, 0.2)',
                borderColor: '#a93226',
                borderWidth: 1,
                fill: false,
                data: checkerRejectedData,
                // hoverBackgroundColor: '#ec7063'
            },
            {
                label: 'Successful',
                backgroundColor: 'rgba(82, 190, 128, 0.2)',
                borderColor: '#52be80',
                borderWidth: 1,
                fill: false,
                data: successfulData,
            },
        ]
    };


    const getLightTheme = () => {
        let basicOptions = {
            maintainAspectRatio: false,
            aspectRatio: .8,
            // plugins: {
            //     legend: {
            //         labels: {
            //             color: '#495057'
            //         }
            //     }
            // },
            title: {
                display: true,
                text: 'Datewise Summary',
                fontSize: 14
            },
            legend: {
                labels: {
                    fontColor: '#495057',
                    fontSize: 10,
                    boxWidth: 10
                }
            },
            scales: {
                xAxes: [{
                    ticks: {
                        fontColor: '#495057'
                    }
                }],
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        fontColor: '#495057'
                    }
                }]
            }
        };

        //     maintainAspectRatio: false,
        //     aspectRatio: .8,
        //     plugins: {
        //         legend: {
        //             labels: {
        //                 color: '#495057'
        //             }
        //         }
        //     },
        //     scales: {
        //         x: {
        //             ticks: {
        //                 color: '#495057'
        //             },
        //             grid: {
        //                 color: '#ebedef'
        //             }
        //         },
        //         y: {
        //             ticks: {
        //                 color: '#495057'
        //             },
        //             grid: {
        //                 color: '#ebedef'
        //             }
        //         }
        //     }
        // };
        return {
            basicOptions,
        }
    }

    const { basicOptions } = getLightTheme();

    const isDataAvailable =
        props?.datewiseData &&
        Array.isArray(props?.datewiseData) &&
        props.datewiseData.length > 0;

    return (
        <>

            <div className="p-col-4">
                <div className="card graph_card position_relative">
                    {/* <h5>Datewise Summary</h5> */}
                    {
                        isDataAvailable ?
                            <Chart type="bar" data={dateWiseData} options={basicOptions} height="290px" />

                            :
                            <div className='no_records'>
                                No Records Found
                            </div>
                    }
                </div>
            </div>

        </>
    )
}

export default Datewise